/* angular:styles/component:css;47e58de1bce0a0a99f0395b0937603096475d0e9be1584518fff86eb9e714e25;/src/src/app/edge/live/Controller/Evse/pages/home.ts */
.oe-modal-buttons-text-size form ion-segment ion-segment-button ion-label {
  white-space: pre-wrap;
  font-size: x-small !important;
}
/*# sourceMappingURL=home.css.map */
